/*    
<summary>
  This functional component "ChooseGroupPopupHOC" provides props to the child component.
  1. State "showAddDevicePopup" that manages the show/hide of pop up
  2. Function "addDeviceToggleHandler" to toggle the show/hide popup state "showAddDevicePopup"
  Developer:Aashish Singh, Created Date:29-March-2023
</summary>
<returns>Returns JSX</returns>
*/
import React, { useState } from "react";

const SignBoardPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showSignBoardPopupHOC, setShowSignBoardPopupHOC] =
      useState<boolean>(false);

    const signBoardPopupToggleHandler = () => {
      setShowSignBoardPopupHOC(!showSignBoardPopupHOC);
    };

    return (
      <Component
        showSignBoardPopupHOC={showSignBoardPopupHOC}
        signBoardPopupToggleHandler={signBoardPopupToggleHandler}
        {...props}
      />
    );
  };

export default SignBoardPopupHOC;
